const monialData = [ 
    {
        id:1,
        desc:'This is the best company that I have Recently work with.Their houses are legit, security is there, water and are located in free polluted areas.',
        img:require('../../assets/testma1.jpg'),
        name:'James Fredric',
        career:'V.Motors C.E.O' 
    },
     {
        id:2,
        desc:'In pursuit of a home for the last 5 years of search, my dream home was brought to reality by Exqui. They are indeed valuable to many across the world.',
        img:require('../../assets/testwo.jpg'),
        name:'Sharon Mutua',
        career:'Entrepreneur' 
    },
     {
        id:3,
        desc:'I got a perfect home for my family through Exqui. Also my first car was sold to me by them and the house furnitures. Exqui is the place to be.',
        img:require('../../assets/testma2.jpg'),
        name:'Andrew Machal',
        career:'Lawyer' 
    }
];

export default monialData;